import { css } from '@emotion/react';
import { Flex } from 'components/box';
import Button from 'components/button';
import { Info as MoreInfoIcon } from 'react-feather';
import { Text } from 'components/typography';
import { FlexProps } from 'components/box';

const MoreInfo = ({
  label,
  callback,
  justifyContent = ['start', null, 'end'],
}: {
  label?: string;
  callback?: () => void;
  justifyContent?: FlexProps['justifyContent'];
}) => (
  <Button
    variant="flat"
    onClick={callback}
    lineHeight="1.6em"
    display="inline"
    p={0}
    css={css`
      border: none;
    `}
  >
    <Flex
      justifyContent={justifyContent}
      alignItems="center"
      color="darkGrey"
      css={theme => css`
        &:hover {
          color: ${theme.colors.primary};
        }
      `}
    >
      <Text
        fontSize={[1, 2, 1]}
        fontWeight="normal"
        letterSpacing={0}
        fontFamily="body"
        css={css`
          text-transform: none;
        `}
      >
        {label}
      </Text>

      <MoreInfoIcon
        size={18}
        css={theme => css`
          margin-left: ${theme.space[2]}px;
        `}
      />
    </Flex>
  </Button>
);

export default MoreInfo;
